import { initializeApp } from "firebase/app";

import firebase from "firebase";
import projectConfig from "@projectConfig";

// Import the functions you need from the SDKs you need

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

let firebaseConfig;

const { scope } = projectConfig.api;

const chooseScope = () => {
   if (projectConfig?.hideChat === false) {
      switch (scope) {
         case "QUALITY_ASSURANCE":
            return (firebaseConfig = {
               apiKey: "AIzaSyBja7o0w6UNAStLXnz-YSq1L4dMKlfnY5M",
               authDomain: "chat-94f8a.firebaseapp.com",
               databaseURL: "https://chat-94f8a-default-rtdb.europe-west1.firebasedatabase.app",
               projectId: "chat-94f8a",
               storageBucket: "chat-94f8a.appspot.com",
               messagingSenderId: "1057798837211",
               appId: "1:1057798837211:web:3e9c29e5373da8bb170dfe",
            });
         case "PRODUCTION":
            return (firebaseConfig = {
               apiKey: "AIzaSyDTg2htcObdldm8H4SsYJsjfSl_WkAM7dk",
               authDomain: "aplog-3907c.firebaseapp.com",
               databaseURL: "https://aplog-3907c-default-rtdb.europe-west1.firebasedatabase.app",
               // new database:
               // https://aplog-3907c-default-rtdb.europe-west1.firebasedatabase.app
               // old one:
               // https://chatprod-6006d-default-rtdb.europe-west1.firebasedatabase.app
               projectId: "aplog-3907c",
               storageBucket: "aplog-3907c.firebasestorage.app",
               messagingSenderId: "872300719026",
               appId: "1:872300719026:web:3bc2fe105f4884ab5292ab",
               measurementId: "G-R84ZDM8V5H",
            });
      }
   }
};

chooseScope();

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default firebase;
